import React from 'react';
import { Button, Dialog, Typography, IconButton, Stack } from '@mui/material';
import { useModals } from '@mattjennings/react-modal-stack';
import Iconify from '../Iconify';

const Fan2FanRedirectDialog = ({
  open,
  onConfirm = () => {},
  onCancel = () => {},
  title,
  text,
  backLabel,
  acceptLabel,
}) => {
  const { closeModal } = useModals();

  if (!open) {
    return null;
  }

  const handleClose = () => {
    closeModal();
    onCancel();
  };

  const handleAcept = () => {
    closeModal();
    onConfirm();
    onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      maxWidth="xs"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Stack
        gap={2}
        sx={{
          padding: { xs: '12px 24px 24px 24px', sm: '14px 32px 32px 32px' },
        }}
      >
        <Stack
          direction="row"
          justifyContent="flex-end"
          sx={{
            mr: -1,
            mb: '-16px',
          }}
        >
          <IconButton onClick={handleClose}>
            <Iconify icon="icon-park:close-small" />
          </IconButton>
        </Stack>
        <Stack gap={3}>
          <Stack gap={1}>
            <Typography
              variant="h5"
              sx={{ fontSize: { xs: '16px', md: '18px' }, lineHeight: '140%' }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: '14px', lineHeight: '140%' }}
            >
              {text}{' '}
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="flex-end"
            gap={1}
          >
            {backLabel && (
              <Button onClick={handleClose} variant="text">
                {backLabel}
              </Button>
            )}
            <Button onClick={handleAcept} autoFocus variant="contained">
              {acceptLabel}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default Fan2FanRedirectDialog;
